import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
export const useJoinNetworkWithToken = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    return useMutation((input) => client.auth.joinNetworkWithToken(input, fields), useMutationOptions);
};
//# sourceMappingURL=useJoinNetworkWithToken.js.map